import { useDispatch } from 'react-redux';

import {
  createMetalStreamAllocation,
  updateMetalStreamAllocation,
} from '../store/actions/metalStream/metalStreamActions';
import { metalStreamDataHelper } from '../util/helpers/metalStreamDataHelper';
import useApplicationUid from './useApplicationUid';
import { useMetalStreamData } from './useMetalStreamData';

const useMetalStreamAllocationDispatch = () => {
  const dispatch = useDispatch();
  const { MetalStreamData } = useMetalStreamData();

  const { ApplicationUid } = useApplicationUid();

  const metalStreamAllocationDispatch = ({ data, onSuccess, onError }) => {
    const goldPercentage = metalStreamDataHelper(
      MetalStreamData,
      'GoldPercentage',
    );
    const silverPercentage = metalStreamDataHelper(
      MetalStreamData,
      'SilverPercentage',
    );

    const { GoldPercentage, SilverPercentage } = data;

    const shouldSkip =
      GoldPercentage === goldPercentage &&
      SilverPercentage === silverPercentage;

    if (shouldSkip) {
      onSuccess();
      return;
    }

    if (goldPercentage || silverPercentage) {
      dispatch(
        updateMetalStreamAllocation({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    } else {
      dispatch(
        createMetalStreamAllocation({
          ApplicationUid,
          data,
          onSuccess,
          onError,
        }),
      );
    }
  };

  return { metalStreamAllocationDispatch };
};

export default useMetalStreamAllocationDispatch;
